import type { PromotionalOffer } from '@/config/objects/promotional-offers';
import { useOutletContext } from 'react-router-dom';

interface PromotionalOfferContext {
  offer: PromotionalOffer | undefined;
  isLoading: boolean;
}

export function usePromotionalOfferContext() {
  return useOutletContext<PromotionalOfferContext>();
}
